/**
 * Sale merch LP + Chef Sven ATC:
 * - Every successful ATC opens the cart drawer (first item included).
 * - Drawer HTML comes from stack-shop (sections_url = cart) so stapel snippets render.
 * - Hangfix: unlock scroll after close / back.
 */
(function () {
  'use strict';
  if (window.TLSaleMerch && window.TLSaleMerch.__booted) return;

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function onSaleLp() {
    return !!document.querySelector('[data-tl-sale-lp]');
  }

  function onSvenLp() {
    return !!document.querySelector('[data-tl-sven-lp]');
  }

  function onDrawerShop() {
    return onSaleLp() || onSvenLp();
  }

  function openDrawer() {
    var drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer');
    if (!drawer) return;
    try {
      if (typeof drawer.open === 'function') drawer.open();
    } catch (e) {}
    drawer.classList.add('active', 'is-open', 'animate');
    drawer.setAttribute('open', '');
    document.documentElement.classList.add('tl-cart-drawer-open');
    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
  }

  function unlockPage() {
    document.documentElement.classList.remove('tl-cart-drawer-open', 'overflow-hidden');
    document.body.classList.remove(
      'overflow-hidden',
      'cart-drawer-open',
      'overflow-hidden-tablet',
      'overflow-hidden-mobile',
      'overflow-hidden-desktop'
    );
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.touchAction = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.height = '';
    document.body.style.touchAction = '';
    document.body.style.pointerEvents = '';
    if (typeof removeTrapFocus === 'function') {
      try { removeTrapFocus(); } catch (e) {}
    }
  }

  /** Lazy imgs can stay blank while overflow was locked; nudge them after unlock. */
  function reviveSaleGrid() {
    if (!onSaleLp()) return;
    document.querySelectorAll('[data-tl-sale-lp] img[loading="lazy"]').forEach(function (img) {
      try {
        if (img.complete && img.naturalWidth > 0) return;
        img.loading = 'eager';
        var src = img.currentSrc || img.getAttribute('src') || '';
        if (src && !img.complete) {
          var bump = img.getAttribute('src');
          if (bump) img.setAttribute('src', bump);
        }
      } catch (e) {}
    });
  }

  /**
   * Drawer left open + body.overflow-hidden / html.tl-cart-drawer-open survives
   * bfcache and incomplete close() — clears all scroll locks + revives grid.
   */
  function ensureSalePageScrollable() {
    if (!onDrawerShop()) return;
    var drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer');
    if (drawer) {
      /* Strip open markers BEFORE close() so MutationObserver / privacy sync
         cannot re-apply tl-cart-drawer-open from a leftover [open] attr. */
      drawer.removeAttribute('open');
      drawer.classList.remove('active', 'is-open', 'animate');
      try {
        if (typeof drawer.close === 'function') drawer.close();
      } catch (e) {}
    }
    unlockPage();
    reviveSaleGrid();
  }

  function closeDrawerIfOpen() {
    var drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer');
    if (drawer) {
      drawer.removeAttribute('open');
      drawer.classList.remove('active', 'is-open', 'animate');
      try {
        if (typeof drawer.close === 'function') drawer.close();
      } catch (e) {}
    }
    unlockPage();
    reviveSaleGrid();
  }

  function applyDrawerHtml(html) {
    if (!html) return;
    var host = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
    if (!host) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('#CartDrawer') || doc.querySelector('cart-drawer');
    var apply = window.updateCartDrawer || (window.cartFunctions && window.cartFunctions.updateCartDrawer);
    if (host && next && apply) apply(host, next, false);
  }

  function scrollToGrid() {
    var grid = document.getElementById('tl-sale-grid') || document.getElementById('tl-sale-build');
    if (grid && grid.scrollIntoView) {
      grid.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }

  function goAllProducts() {
    closeDrawerIfOpen();
    if (onSvenLp() && !onSaleLp()) {
      window.location.href = rootPath() + 'pages/set-sale';
      return;
    }
    applySaleFilter('all');
    if (history.replaceState) {
      history.replaceState(null, '', location.pathname + (location.search || ''));
    }
    window.setTimeout(scrollToGrid, 40);
  }

  function showAddError(btn, msg) {
    var card = btn && btn.closest('[data-tl-card], .tl-sale-card, .tl-sven-set, .tl-sven-loose');
    if (!card) {
      window.alert(msg || (window.TL_SA_EN ? 'Couldn’t add this. Please try again.' : 'Kon niet toevoegen. Probeer het opnieuw.'));
      return;
    }
    var err = card.querySelector('[data-tl-sale-err]');
    if (!err) {
      err = document.createElement('p');
      err.setAttribute('data-tl-sale-err', '1');
      err.className = 'tl-sale-card__err';
      var actions = card.querySelector('.tl-sale-card__actions') || card;
      actions.appendChild(err);
    }
    err.hidden = false;
    err.textContent = msg || (window.TL_SA_EN ? 'Couldn’t add this. Please try again.' : 'Kon niet toevoegen. Probeer het opnieuw.');
  }

  function clearAddError(btn) {
    var card = btn && btn.closest('[data-tl-card], .tl-sale-card, .tl-sven-set, .tl-sven-loose');
    var err = card && card.querySelector('[data-tl-sale-err]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
  }

  /* Same picks as snippets/titanore-stapel-upsell.liquid */
  var UPSELL_UTENSIL = '57831504970115';
  var UPSELL_BOARD = '62603798774147';

  function upsellVariantId() {
    var addBtn = document.querySelector('[data-tl-stapel-add]');
    var fromBtn = addBtn && addBtn.getAttribute('data-variant-id');
    if (fromBtn) return String(fromBtn);
    var box = document.querySelector('[data-tl-stapel-upsell]');
    var fromBox = box && box.getAttribute('data-variant-id');
    if (fromBox) return String(fromBox);
    var progress = document.querySelector('[data-tl-stapel-progress]');
    var n = progress ? parseInt(progress.getAttribute('data-tl-item-count'), 10) : NaN;
    if (n === 1) return UPSELL_UTENSIL;
    if (n === 2) return UPSELL_BOARD;
    return '';
  }

  function applyDrawerFromAdd(data) {
    var html = '';
    if (data && typeof data === 'object') {
      html = data['cart-drawer'] || (data.sections && data.sections['cart-drawer']) || '';
    }
    if (html) applyDrawerHtml(html);
    openDrawer();
  }

  function addUpsellVariant(id) {
    if (window.tlStapelCart && typeof window.tlStapelCart.addVariant === 'function') {
      return window.tlStapelCart.addVariant(id);
    }
    return fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer',
        sections_url: rootPath() + 'cart'
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function (data) {
      applyDrawerFromAdd(data);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'tl-stapel-upsell-cta' } }));
    });
  }

  function injectDrawerStackCta() {
    if (!onDrawerShop()) return;
    document.querySelectorAll('[data-tl-sale-continue], cart-drawer .tl-sale-continue, #CartDrawer .tl-sale-continue').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('.tl-cart-ctas--stacking').forEach(function (el) {
      el.classList.remove('tl-cart-ctas--stacking');
    });
    document.querySelectorAll('.tl-cart-cta--secondary').forEach(function (el) {
      el.classList.remove('tl-cart-cta--secondary');
    });
  }

  async function fallbackAdd(btn) {
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var card = btn.closest('[data-tl-card], .tl-sven-set, .tl-sven-loose');
    var id = card && Number(card.getAttribute('data-variant') || 0);
    if (!id) id = Number(btn.getAttribute('data-variant') || 0);
    if (!id) {
      showAddError(btn, (window.TL_SA_EN ? 'This product can’t be added right now.' : 'Dit product kan nu niet worden toegevoegd.'));
      return;
    }
    clearAddError(btn);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.querySelector('[data-tl-add-label]');
    var prev = label ? label.textContent : '';
    if (label) label.textContent = (window.TL_SA_EN ? 'Adding\u2026' : 'Bezig\u2026');
    try {
      var res = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1 }],
          sections: 'cart-drawer',
          sections_url: rootPath() + 'cart'
        })
      });
      var data = await res.json();
      if (!res.ok) throw new Error((data && (data.description || data.message)) || 'add failed');
      var html = data['cart-drawer'] || (data.sections && data.sections['cart-drawer']) || '';
      applyDrawerHtml(html);
      btn.classList.add('is-added');
      if (label) label.textContent = (window.TL_SA_EN ? 'Added' : 'Toegevoegd');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'tl-sale' } }));
      afterAdd(true);
      window.setTimeout(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-added');
        if (label) label.textContent = (window.TL_SA_EN ? 'Add\u00a0to\u00a0cart' : 'In\u00a0winkelwagen');
      }, 1100);
    } catch (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (label) label.textContent = prev || (window.TL_SA_EN ? 'Add\u00a0to\u00a0cart' : 'In\u00a0winkelwagen');
      showAddError(btn, (err && err.message) || (window.TL_SA_EN ? 'Couldn’t add this. Please try again.' : 'Kon niet toevoegen. Probeer het opnieuw.'));
    }
  }

  function stickyBoot() {
    /* 2026-10-01: sticky staffel card disabled — keep bar hidden always */
    var bar = document.querySelector('[data-tl-sale-sticky]');
    if (bar) {
      bar.hidden = true;
      bar.removeAttribute('data-force-show');
    }
  }

  function eligibleFromCart(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    cart.items.forEach(function (item) {
      var h = (item.handle || (item.product && item.product.handle) || '').toLowerCase();
      if (!h || h === 'order-protection' || h.indexOf('cookbook') !== -1 || h === 'the-titanium-table') return;
      if (item.final_price <= 0 && item.price <= 0) return;
      n += item.quantity || 1;
    });
    return n;
  }

  function paintTierNodes(elig) {
    document.querySelectorAll('.tl-sale-tier').forEach(function (el) {
      var t = Number(el.getAttribute('data-tier') || 0);
      el.classList.toggle('is-reached', elig >= t);
      el.classList.toggle('is-current', (elig === 0 && t === 1) || (elig === 1 && t === 1) || (elig === 2 && t === 2) || (elig >= 3 && t === 3));
    });
  }

  function paintStickyProgress(elig) {
    var root = document.querySelector('[data-tl-sale-sticky-progress]');
    if (!root) return;
    root.querySelectorAll('[data-step]').forEach(function (dot) {
      var step = Number(dot.getAttribute('data-step') || 0);
      var filled = elig >= step || (step === 3 && elig >= 3);
      if (step === 1) filled = elig >= 1;
      if (step === 2) filled = elig >= 2;
      if (step === 3) filled = elig >= 3;
      dot.classList.toggle('is-on', filled);
      dot.classList.toggle('is-next', !filled && ((elig === 0 && step === 1) || (elig === 1 && step === 2) || (elig === 2 && step === 3)));
    });
  }

  function paintSticky(cart, pulse) {
    injectDrawerStackCta();
    var copy = document.querySelector('[data-tl-sale-sticky-copy]');
    var cta = document.querySelector('[data-tl-sale-sticky-cta]');
    var bar = document.querySelector('[data-tl-sale-sticky]');
    if (!copy || !cta) return;
    var elig = 0;
    if (cart) elig = eligibleFromCart(cart);
    else if (window.TLTierAdapter && TLTierAdapter.getState) {
      var st = TLTierAdapter.getState();
      if (st && typeof st.elig === 'number') elig = st.elig;
      else if (st && typeof st.qualifyingCount === 'number') elig = st.qualifyingCount;
    }
    paintStickyProgress(elig);
    paintTierNodes(elig);
    injectDrawerStackCta(elig);
    if (elig <= 0) {
      copy.textContent = (window.TL_SA_EN ? '2 = 10% extra on your whole cart · 3+ = 20% extra' : '2 = 10% extra op je hele mand · 3+ = 20% extra');
      cta.textContent = (window.TL_SA_EN ? 'Shop the sale' : 'Shop de actie');
      cta.setAttribute('href', '#tl-sale-grid');
      cta.removeAttribute('data-open-cart');
      if (bar) bar.removeAttribute('data-force-show');
    } else if (elig === 1) {
      copy.textContent = (window.TL_SA_EN ? 'Add 1 more product for 10% extra' : 'Nog 1 product toevoegen voor 10% extra setvoordeel');
      cta.textContent = (window.TL_SA_EN ? 'Add 1' : 'Voeg 1 toe');
      cta.setAttribute('href', '#tl-sale-grid');
      cta.removeAttribute('data-open-cart');
      if (bar) bar.removeAttribute('data-force-show');
    } else if (elig === 2) {
      copy.textContent = (window.TL_SA_EN ? 'Add 1 more product for 20% extra' : 'Nog 1 product toevoegen voor 20% extra setvoordeel');
      cta.textContent = (window.TL_SA_EN ? 'Add 1' : 'Voeg 1 toe');
      cta.setAttribute('href', '#tl-sale-grid');
      cta.removeAttribute('data-open-cart');
      if (bar) bar.removeAttribute('data-force-show');
    } else {
      copy.textContent = (window.TL_SA_EN ? '20% extra is active on your whole cart' : '20% extra setvoordeel is actief op je hele mand');
      cta.textContent = (window.TL_SA_EN ? 'Go to cart' : 'Naar winkelmand');
      cta.setAttribute('href', '#');
      cta.setAttribute('data-open-cart', '1');
      if (bar) bar.removeAttribute('data-force-show');
    }
    if (bar) {
      bar.hidden = true;
      bar.removeAttribute('data-force-show');
      bar.classList.remove('is-pulse');
    }
    return elig;
  }

  function refreshStickyFromCart(pulse) {
    return fetch(rootPath() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return 0;
        return paintSticky(cart, !!pulse) || 0;
      })
      .catch(function () { return 0; });
  }

  /** After every successful ATC: refresh totals, then open the drawer. */
  function afterAdd(pulse) {
    return refreshStickyFromCart(!!pulse).then(function (elig) {
      window.setTimeout(openDrawer, 80);
      return elig;
    });
  }

  function boot() {
    window.TLSaleMerch = {
      __booted: true,
      openDrawer: openDrawer,
      paintSticky: paintSticky,
      closeDrawerIfOpen: closeDrawerIfOpen,
      afterAdd: afterAdd,
      unlockPage: unlockPage,
      ensureSalePageScrollable: ensureSalePageScrollable
    };
    if (!onDrawerShop()) return;
    ensureSalePageScrollable();
    if (onSaleLp()) {
      document.querySelectorAll('.tl-sale-cats').forEach(function (el) {
        el.style.setProperty('position', 'static', 'important');
        el.style.setProperty('top', 'auto', 'important');
        el.style.setProperty('transform', 'none', 'important');
      });
      bindSaleHashNav();
      stickyBoot();
      paintSticky();
      refreshStickyFromCart();
    }
    /* bfcache / back / drawer leftovers: clear scroll lock */
    window.addEventListener('pageshow', function () {
      ensureSalePageScrollable();
      window.setTimeout(ensureSalePageScrollable, 50);
      window.setTimeout(ensureSalePageScrollable, 300);
    });
    window.addEventListener('popstate', function () {
      window.setTimeout(ensureSalePageScrollable, 0);
      window.setTimeout(ensureSalePageScrollable, 100);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') ensureSalePageScrollable();
    });
    document.addEventListener('cart-drawer:close', function () {
      unlockPage();
      reviveSaleGrid();
      window.setTimeout(function () {
        unlockPage();
        refreshStickyFromCart(true);
      }, 50);
    });
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target && e.target.closest && e.target.closest('.tl-sale-card a[href]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
        unlockPage();
      },
      true
    );
    document.addEventListener('cart:updated', function (e) {
      if (!onDrawerShop()) return;
      var src = e && e.detail && e.detail.source;
      if (src && String(src).indexOf('tl-') === 0) {
        afterAdd(true);
        return;
      }
      refreshStickyFromCart(false);
    });
    document.addEventListener(
      'click',
      function (e) {
        var cont = e.target && e.target.closest && e.target.closest('[data-tl-sale-continue].tl-sale-continue, [data-tl-upsell-cta]');
        if (!cont || cont.getAttribute('data-tl-upsell-cta') !== '1') return;
        var vid = cont.getAttribute('data-variant-id');
        if (!vid || !onDrawerShop()) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (cont.disabled) return;
        cont.disabled = true;
        addUpsellVariant(vid)
          .catch(function () {})
          .finally(function () {
            cont.disabled = false;
            refreshStickyFromCart(false);
          });
      },
      true
    );
    document.addEventListener('click', function (e) {
      var cont = e.target && e.target.closest && e.target.closest('[data-tl-sale-continue], .tl-sale-continue, #Zt-CloseCartDrawer, .Zt-continue-btn, .tl-cart-continue');
      if (!cont || cont.getAttribute('data-tl-upsell-cta') === '1') return;
      if (cont && onSvenLp() && !onSaleLp()) {
        e.preventDefault();
        goAllProducts();
      }
    });
    document.addEventListener('click', function (e) {
      var cta = e.target && e.target.closest && e.target.closest('[data-open-cart]');
      if (cta) {
        e.preventDefault();
        openDrawer();
        refreshStickyFromCart(false);
      }
    });
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-tl-sale-lp] [data-tl-quick-add], [data-tl-sven-lp] [data-tl-sven-atc], [data-tl-sven-lp] [data-tl-quick-add]');
        if (!btn) return;
        if (!(window.TLStackShop && window.TLStackShop.__booted)) {
          e.preventDefault();
          e.stopPropagation();
          fallbackAdd(btn);
          return;
        }
        window.setTimeout(function () {
          if (btn.classList.contains('is-added') || btn.getAttribute('aria-busy') === 'true') {
            afterAdd(true);
          } else {
            refreshStickyFromCart(true);
          }
        }, 520);
      },
      true
    );
    document.addEventListener('click', function (e) {
      var closer = e.target && e.target.closest && e.target.closest('cart-drawer .drawer__close, #CartDrawer .drawer__close, [is="close-cart"], .cart-drawer__close, cart-drawer .cart-drawer__overlay, #CartDrawer-Overlay');
      if (closer) {
        window.setTimeout(function () {
          unlockPage();
          reviveSaleGrid();
          refreshStickyFromCart(true);
        }, 50);
        window.setTimeout(unlockPage, 200);
      }
    });
    ['cart-drawer:update', 'cart-drawer:render', 'cart:refresh'].forEach(function (name) {
      document.addEventListener(name, function () {
        if (!onDrawerShop()) return;
        window.setTimeout(function () { refreshStickyFromCart(false); }, 80);
      });
    });
  }

  function saleCatIds() {
    return ['sets', 'pannen', 'kookpannen', 'wokpannen', 'andere-pannen', 'planken', 'accessoires'];
  }

  function paintSaleCatActive(hash) {
    var id = String(hash || '').replace('#', '');
    if (!id || id === 'tl-sale-grid') id = 'all';
    document.querySelectorAll('.tl-sale-cats a').forEach(function (el) {
      var key = el.getAttribute('data-sale-filter') || '';
      var on = key === id;
      el.classList.toggle('is-on', on);
      if (on) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
  }

  function applySaleFilter(id) {
    var root = document.querySelector('[data-tl-sale-lp]');
    if (!root) return;
    var all = !id || id === 'all' || id === 'tl-sale-grid';
    var key = all ? 'all' : id;
    root.classList.toggle('is-filtering', !all);
    document.querySelectorAll('.tl-sale-item, .tl-sale-group').forEach(function (el) {
      var cat = el.getAttribute('data-sale-cat') || '';
      var on = all || cat === key;
      if (el.classList.contains('tl-sale-item')) {
        el.style.display = on ? '' : 'none';
      } else {
        el.hidden = !on;
      }
    });
    var more = document.querySelector('.tl-sale-more');
    if (more) more.hidden = !all;
    paintSaleCatActive(key);
  }

  function scrollToSaleHash() {
    var id = (location.hash || '').replace('#', '');
    if (!id || id === 'tl-sale-grid' || id === 'all') {
      applySaleFilter('all');
      return;
    }
    applySaleFilter(saleCatIds().indexOf(id) >= 0 ? id : 'all');
    var el = document.getElementById('tl-sale-grid');
    if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  function isAllProductsHref(href) {
    if (!href) return false;
    var path = href.split('#')[0].split('?')[0];
    return /\/pages\/set-sale\/?$/.test(path) || /\/collections\/(all|all-products|alle-pannen)\/?$/.test(path);
  }

  function bindSaleHashNav() {
    if (!onSaleLp()) return;
    document.addEventListener('click', function (e) {
      var cont = e.target && e.target.closest && e.target.closest('[data-tl-sale-continue], .tl-sale-continue, #Zt-CloseCartDrawer, .Zt-continue-btn, .tl-cart-continue');
      if (cont) {
        if (cont.getAttribute('data-tl-upsell-cta') === '1') return;
        e.preventDefault();
        goAllProducts();
        return;
      }
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hash = href.indexOf('#') >= 0 ? href.slice(href.indexOf('#') + 1) : '';
      var filter = a.getAttribute('data-sale-filter') || '';
      var headerAll = isAllProductsHref(href) && (!hash || hash === 'tl-sale-grid');
      var catLink = a.closest('.tl-sale-cats') || /set-sale#/.test(href) || /^(sets|pannen|kookpannen|wokpannen|andere-pannen|planken|accessoires|tl-sale-grid)$/.test(hash);
      if (!headerAll && !catLink && !filter) return;
      e.preventDefault();
      closeDrawerIfOpen();
      if (headerAll || filter === 'all' || hash === 'tl-sale-grid' || hash === 'all' || (!hash && !filter)) {
        goAllProducts();
        return;
      }
      var next = filter || hash;
      if (history.replaceState) history.replaceState(null, '', '#' + next);
      applySaleFilter(next);
      scrollToGrid();
    });
    scrollToSaleHash();
    window.addEventListener('hashchange', scrollToSaleHash);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
